import * as React from "react"

function Icon3(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      {...props}
    >
      <title>{"ICON 3"}</title>
      <g fill="none" fillRule="evenodd">
        <path
          d="M31 5c8.837 0 16 7.163 16 16 0 5.499-2.774 10.35-6.999 13.23L40 52l-9-9-9 9V34.23c-4.226-2.88-7-7.73-7-13.23 0-8.837 7.163-16 16-16z"
          stroke="#FFF"
          strokeWidth={2}
        />
        <circle stroke="#FFF" strokeWidth={2} cx={31} cy={21} r={16} />
        <circle stroke="#E3E833" strokeWidth={2} cx={31} cy={21} r={9} />
      </g>
    </svg>
  )
}

export default Icon3